export default __webpack_public_path__ + "static/media/table-sort-icon-up.59a4d709.svg";